export default [
    {
        path: "/data/dy/rank",
        name: "data-dy-rank",
        component: () => import("@/views/data/dy/rank.vue"),
    },
    {
        path: "/data/dy/creative",
        name: "data-dy-creative",
        component: () => import("@/views/data/dy/creative.vue"),
    },
    {
        path: "/data/dy/kol/list",
        name: "data-dy-kol-list",
        component: () => import("@/views/data/dy/kol/list.vue"),
    },
    {
        path: "/data/xhs/view",
        name: "data-xhs-view",
        component: () => import("@/views/data/xhs/view.vue"),
    },
    {
        path: "/data/xhs/kol/list",
        name: "data-xhs-kol-list",
        component: () => import("@/views/data/xhs/kol/list.vue"),
    },
    {
        path: "/data/xhs/kol/detail",
        name: "data-xhs-kol-detail",
        component: () => import("@/views/data/xhs/kol/detail.vue"),
    },
    {
        path: "/data/sv/search",
        name: "data-sv-search",
        component: () => import("@/views/data/util/svsearch.vue"),
    },
    {
        path: "/data/util/keyword",
        name: "data-util-keyword",
        component: () => import("@/views/data/util/keyword.vue"),
    },
    {
        path: "/data/mlxx/view",
        name: "data-mlxx-view",
        component: () => import("@/views/data/mlxx/view.vue"),
    },
    {
        path: "/data/xhs/note/list",
        name: "data-xhs-note-list",
        component: () => import("@/views/data/xhs/note/list.vue"),
    },
]